// import React, { useEffect, useMemo, useState } from "react";
// import "../MainCategories/mainCategories.css"; // reuse same css (optional)

// const API_MAIN_LIST = "https://xiadot.com/vendor_api/vendor/main_categories/list.php";
// const API_SUB_LIST = "https://xiadot.com/vendor_api/vendor/sub_categories/list.php";
// const API_SUB_ADD = "https://xiadot.com/vendor_api/vendor/sub_categories/add.php";
// const API_SUB_UPDATE = "https://xiadot.com/vendor_api/vendor/sub_categories/update.php"; // ✅ NEW
// const API_SUB_DELETE = "https://xiadot.com/vendor_api/vendor/sub_categories/delete.php";

// export default function SubCategoriesPage() {
//   // ✅ TOKEN (IMPORTANT)
//   const token =
//     localStorage.getItem("vendor_token") ||
//     localStorage.getItem("token") ||
//     "";

//   const authHeaders = token ? { Authorization: "Bearer " + token } : {};

//   const [mainCats, setMainCats] = useState([]);
//   const [rows, setRows] = useState([]);

//   const [q, setQ] = useState("");
//   const [open, setOpen] = useState(false);
//   const [loading, setLoading] = useState(false);

//   // ✅ add/edit mode
//   const [mode, setMode] = useState("add"); // "add" | "edit"

//   // ✅ form
//   const [form, setForm] = useState({
//     id: "", // ✅ NEW for edit
//     category_id: "",
//     name: "",
//     status: "Active",
//   });

//   /* ---------------- Load Main Categories (dropdown) ---------------- */
//   const loadMainCats = async () => {
//     try {
//       const res = await fetch(API_MAIN_LIST, { headers: authHeaders });
//       const data = await res.json().catch(() => ({}));

//       if (!res.ok || data?.success === false) {
//         throw new Error(data?.message || "Main categories load failed");
//       }

//       const list = data?.categories || data?.data || [];
//       const safe = Array.isArray(list) ? list : [];
//       setMainCats(safe);

//       // default select first category (only when adding)
//       if (mode === "add" && !form.category_id && safe.length > 0) {
//         setForm((p) => ({ ...p, category_id: String(safe[0].id) }));
//       }
//     } catch (e) {
//       console.log("loadMainCats error:", e);
//       setMainCats([]);
//     }
//   };

//   /* ---------------- Load Sub Categories (table) ---------------- */
//   const loadSubCats = async () => {
//     setLoading(true);
//     try {
//       const res = await fetch(API_SUB_LIST, { headers: authHeaders });
//       const data = await res.json().catch(() => ({}));

//       if (!res.ok || data?.success === false) {
//         throw new Error(data?.message || "Sub categories load failed");
//       }

//       const list = data?.subcategories || [];
//       setRows(Array.isArray(list) ? list : []);
//     } catch (e) {
//       console.log("loadSubCats error:", e);
//       setRows([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (!token) console.log("Token missing in localStorage. Login first.");
//     loadMainCats();
//     loadSubCats();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   /* ---------------- Search filter ---------------- */
//   const filtered = useMemo(() => {
//     const s = q.trim().toLowerCase();
//     if (!s) return rows;

//     return rows.filter((r) => {
//       const mainName = (r.category || "").toLowerCase(); // backend key: category
//       const subName = (r.subcategory || "").toLowerCase(); // backend key: subcategory
//       return mainName.includes(s) || subName.includes(s);
//     });
//   }, [rows, q]);

//   /* ---------------- Open Add Modal ---------------- */
//   const openAdd = () => {
//     setMode("add");
//     setForm((p) => ({
//       ...p,
//       id: "",
//       name: "",
//       status: "Active",
//       // keep selected category_id as-is
//     }));
//     setOpen(true);
//   };

//   /* ---------------- Open Edit Modal ---------------- */
//   const openEdit = (r) => {
//     setMode("edit");

//     // ✅ list.php returns: id, category, subcategory, status
//     // We also need category_id for update.
//     // Some APIs send category_id directly. If not, we map using mainCats by name.
//     const found = mainCats.find((c) => String(c.name) === String(r.category));
//     const category_id = r.category_id ? String(r.category_id) : found ? String(found.id) : "";

//     setForm({
//       id: String(r.id),
//       category_id,
//       name: r.subcategory || "",
//       status: r.status || "Active",
//     });

//     setOpen(true);
//   };

//   /* ---------------- Add Sub Category ---------------- */
//   const add = async () => {
//     if (!form.category_id) return alert("Select Main Category");
//     if (!form.name.trim()) return alert("Enter Sub Category Name");

//     setLoading(true);
//     try {
//       const fd = new FormData();
//       fd.append("category_id", form.category_id);
//       fd.append("name", form.name.trim());
//       fd.append("status", form.status);

//       const res = await fetch(API_SUB_ADD, {
//         method: "POST",
//         headers: authHeaders,
//         body: fd,
//       });

//       const data = await res.json().catch(() => ({}));
//       if (!res.ok || data?.success === false) {
//         throw new Error(data?.message || "Add failed");
//       }

//       setOpen(false);
//       setForm((p) => ({ ...p, id: "", name: "", status: "Active" }));
//       await loadSubCats();
//     } catch (e) {
//       alert(e.message || "Add failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ---------------- Update Sub Category ---------------- */
//   const update = async () => {
//     if (!form.id) return alert("Missing id");
//     if (!form.category_id) return alert("Select Main Category");
//     if (!form.name.trim()) return alert("Enter Sub Category Name");

//     setLoading(true);
//     try {
//       const fd = new FormData();
//       fd.append("id", form.id);
//       fd.append("category_id", form.category_id);
//       fd.append("name", form.name.trim());
//       fd.append("status", form.status);

//       const res = await fetch(API_SUB_UPDATE, {
//         method: "POST",
//         headers: authHeaders,
//         body: fd,
//       });

//       const data = await res.json().catch(() => ({}));
//       if (!res.ok || data?.success === false) {
//         throw new Error(data?.message || "Update failed");
//       }

//       setOpen(false);
//       setMode("add");
//       setForm((p) => ({ ...p, id: "", name: "", status: "Active" }));
//       await loadSubCats();
//     } catch (e) {
//       alert(e.message || "Update failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ---------------- Delete Sub Category ---------------- */
//   const remove = async (id) => {
//     if (!window.confirm("Delete this sub category?")) return;

//     setLoading(true);
//     try {
//       const fd = new FormData();
//       fd.append("id", String(id));

//       const res = await fetch(API_SUB_DELETE, {
//         method: "POST",
//         headers: authHeaders,
//         body: fd,
//       });

//       const data = await res.json().catch(() => ({}));
//       if (!res.ok || data?.success === false) {
//         throw new Error(data?.message || "Delete failed");
//       }

//       await loadSubCats();
//     } catch (e) {
//       alert(e.message || "Delete failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="mc-page">
//       <div className="mc-head">
//         <h1 className="mc-title">Sub Categories</h1>

//         <div className="mc-tools">
//           <div className="mc-search">
//             <span className="mc-searchIcon">🔎</span>
//             <input
//               value={q}
//               onChange={(e) => setQ(e.target.value)}
//               placeholder="Search sub category..."
//             />
//           </div>

//           <button className="mc-addBtn" onClick={openAdd}>
//             + Add Sub Category
//           </button>
//         </div>
//       </div>

//       <div className="mc-card">
//         <table className="mc-table">
//           <thead>
//             <tr>
//               <th style={{ width: 80 }}>S.NO</th>
//               <th>MAIN CATEGORY</th>
//               <th>SUB CATEGORY</th>
//               <th style={{ width: 160 }}>STATUS</th>
//               <th style={{ width: 180 }}>ACTIONS</th>
//             </tr>
//           </thead>

//           <tbody>
//             {loading ? (
//               <tr>
//                 <td colSpan={5} className="mc-empty">
//                   Loading...
//                 </td>
//               </tr>
//             ) : filtered.length === 0 ? (
//               <tr>
//                 <td colSpan={5} className="mc-empty">
//                   No sub categories found
//                 </td>
//               </tr>
//             ) : (
//               filtered.map((r, idx) => (
//                 <tr key={r.id}>
//                   <td>{idx + 1}</td>
//                   <td style={{ fontWeight: 700 }}>{r.category || "—"}</td>
//                   <td className="mc-nameCell">{r.subcategory || "—"}</td>
//                   <td>
//                     <span
//                       className={`mc-status ${r.status === "Active" ? "on" : "off"}`}
//                     >
//                       ● {r.status}
//                     </span>
//                   </td>

//                   <td className="mc-actions">
//                     {/* ✅ EDIT */}
//                     <button
//                       className="mc-iconBtn"
//                       onClick={() => openEdit(r)}
//                       title="Edit"
//                     >
//                       ✏️
//                     </button>

//                     {/* ✅ DELETE */}
//                     <button
//                       className="mc-iconBtn danger"
//                       onClick={() => remove(r.id)}
//                       title="Delete"
//                     >
//                       🗑️
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* ✅ Add/Edit Modal */}
//       {open && (
//         <div className="mc-overlay" onMouseDown={() => setOpen(false)}>
//           <div className="mc-modal" onMouseDown={(e) => e.stopPropagation()}>
//             <div className="mc-modalHead">
//               <h3>{mode === "edit" ? "Edit Sub Category" : "Add Sub Category"}</h3>
//               <button className="mc-x" onClick={() => setOpen(false)}>
//                 ✕
//               </button>
//             </div>

//             <div className="mc-form">
//               <label>Main Category</label>
//               <select
//                 value={form.category_id}
//                 onChange={(e) =>
//                   setForm((p) => ({ ...p, category_id: e.target.value }))
//                 }
//               >
//                 <option value="">Select Main Category</option>
//                 {mainCats.map((c) => (
//                   <option key={c.id} value={c.id}>
//                     {c.name}
//                   </option>
//                 ))}
//               </select>

//               <label style={{ marginTop: 10 }}>Sub Category Name</label>
//               <input
//                 value={form.name}
//                 onChange={(e) =>
//                   setForm((p) => ({ ...p, name: e.target.value }))
//                 }
//                 placeholder="Sub Category Name"
//               />

//               <label style={{ marginTop: 10 }}>Status</label>
//               <select
//                 value={form.status}
//                 onChange={(e) =>
//                   setForm((p) => ({ ...p, status: e.target.value }))
//                 }
//               >
//                 <option>Active</option>
//                 <option>Inactive</option>
//               </select>

//               <button
//                 className="mc-saveBtn"
//                 onClick={mode === "edit" ? update : add}
//                 disabled={loading}
//               >
//                 {loading
//                   ? "Saving..."
//                   : mode === "edit"
//                   ? "Update Sub Category"
//                   : "Save Sub Category"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

//new

import React, { useEffect, useMemo, useState } from "react";
import "./subCategories.css";

const API_MAIN_LIST  = "https://xiadot.com/vendor_api/vendor/main_categories/list.php";
const API_SUB_LIST   = "https://xiadot.com/vendor_api/vendor/sub_categories/list.php";
const API_SUB_ADD    = "https://xiadot.com/vendor_api/vendor/sub_categories/add.php";
const API_SUB_UPDATE = "https://xiadot.com/vendor_api/vendor/sub_categories/update.php";
const API_SUB_DELETE = "https://xiadot.com/vendor_api/vendor/sub_categories/delete.php";

export default function SubCategoriesPage() {
  const token = localStorage.getItem("vendor_token") || localStorage.getItem("token") || "";
  const authHeaders = token ? { Authorization: "Bearer " + token } : {};

  const [mainCats, setMainCats] = useState([]);
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [mode, setMode] = useState("add");
  const [formErr, setFormErr] = useState("");
  const [form, setForm] = useState({ id: "", category_id: "", name: "", status: "Active" });

  const loadMainCats = async () => {
    try {
      const res = await fetch(API_MAIN_LIST, { headers: authHeaders });
      const data = await res.json().catch(() => ({}));
      const list = data?.categories || data?.data || [];
      const safe = Array.isArray(list) ? list : [];
      setMainCats(safe);
      if (mode === "add" && !form.category_id && safe.length > 0)
        setForm((p) => ({ ...p, category_id: String(safe[0].id) }));
    } catch { setMainCats([]); }
  };

  const loadSubCats = async () => {
    setLoading(true);
    try {
      const res = await fetch(API_SUB_LIST, { headers: authHeaders });
      const data = await res.json().catch(() => ({}));
      const list = data?.subcategories || [];
      setRows(Array.isArray(list) ? list : []);
    } catch { setRows([]); }
    finally { setLoading(false); }
  };

  useEffect(() => {
    loadMainCats();
    loadSubCats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return rows;
    return rows.filter((r) =>
      (r.category || "").toLowerCase().includes(s) ||
      (r.subcategory || "").toLowerCase().includes(s)
    );
  }, [rows, q]);

  const openAdd = () => {
    setMode("add"); setFormErr("");
    setForm((p) => ({ ...p, id: "", name: "", status: "Active" }));
    setOpen(true);
  };

  const openEdit = (r) => {
    setMode("edit"); setFormErr("");
    const found = mainCats.find((c) => String(c.name) === String(r.category));
    const category_id = r.category_id ? String(r.category_id) : found ? String(found.id) : "";
    setForm({ id: String(r.id), category_id, name: r.subcategory || "", status: r.status || "Active" });
    setOpen(true);
  };

  const closeModal = () => { setOpen(false); setFormErr(""); };

  const add = async () => {
    setFormErr("");
    if (!form.category_id) { setFormErr("Please select a main category"); return; }
    if (!form.name.trim()) { setFormErr("Sub category name is required"); return; }
    setSaving(true);
    try {
      const fd = new FormData();
      fd.append("category_id", form.category_id);
      fd.append("name", form.name.trim());
      fd.append("status", form.status);
      const res = await fetch(API_SUB_ADD, { method: "POST", headers: authHeaders, body: fd });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || data?.success === false) throw new Error(data?.message || "Add failed");
      closeModal();
      setForm((p) => ({ ...p, id: "", name: "", status: "Active" }));
      await loadSubCats();
    } catch (e) { setFormErr(e.message || "Add failed"); }
    finally { setSaving(false); }
  };

  const update = async () => {
    setFormErr("");
    if (!form.id) { setFormErr("Missing ID"); return; }
    if (!form.category_id) { setFormErr("Please select a main category"); return; }
    if (!form.name.trim()) { setFormErr("Sub category name is required"); return; }
    setSaving(true);
    try {
      const fd = new FormData();
      fd.append("id", form.id);
      fd.append("category_id", form.category_id);
      fd.append("name", form.name.trim());
      fd.append("status", form.status);
      const res = await fetch(API_SUB_UPDATE, { method: "POST", headers: authHeaders, body: fd });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || data?.success === false) throw new Error(data?.message || "Update failed");
      closeModal();
      await loadSubCats();
    } catch (e) { setFormErr(e.message || "Update failed"); }
    finally { setSaving(false); }
  };

  const remove = async (id) => {
    if (!window.confirm("Delete this sub category?")) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("id", String(id));
      const res = await fetch(API_SUB_DELETE, { method: "POST", headers: authHeaders, body: fd });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || data?.success === false) throw new Error(data?.message || "Delete failed");
      await loadSubCats();
    } catch (e) { alert(e.message || "Delete failed"); }
    finally { setLoading(false); }
  };

  // get main cat name by id
  const getMainName = (r) => r.category || mainCats.find((c) => String(c.id) === String(r.category_id))?.name || "—";

  return (
    <div className="sc-page">

      {/* Header */}
      <div className="sc-header">
        <div className="sc-header-left">
          <div className="sc-header-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/>
              <line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/>
              <line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>
            </svg>
          </div>
          <div>
            <h1 className="sc-title">Sub Categories</h1>
            <p className="sc-subtitle">{rows.length} {rows.length === 1 ? "sub category" : "sub categories"} total</p>
          </div>
        </div>
        <button className="sc-add-btn" onClick={openAdd}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
          </svg>
          Add Sub Category
        </button>
      </div>

      {/* Toolbar */}
      <div className="sc-toolbar">
        <div className="sc-search">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
          </svg>
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by main or sub category…" />
          {q && (
            <button className="sc-search-clear" onClick={() => setQ("")}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          )}
        </div>
        <div className="sc-count">
          Showing <strong>{filtered.length}</strong> of <strong>{rows.length}</strong>
        </div>
      </div>

      {/* Cards */}
      {loading ? (
        <div className="sc-state">
          <div className="sc-spinner" />
          <p>Loading sub categories…</p>
        </div>
      ) : filtered.length === 0 ? (
        <div className="sc-state">
          <div className="sc-empty-icon">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
              <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/>
              <line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/>
              <line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>
            </svg>
          </div>
          <p className="sc-empty-title">{q ? "No results found" : "No sub categories yet"}</p>
          <p className="sc-empty-sub">{q ? `No matches for "${q}"` : "Click Add Sub Category to get started"}</p>
        </div>
      ) : (
        <div className="sc-grid">
          {filtered.map((r) => (
            <div className="sc-card" key={r.id}>
              <div className="sc-card-avatar">
                {(r.subcategory || "?").charAt(0).toUpperCase()}
              </div>
              <div className="sc-card-body">
                <div className="sc-card-top">
                  <h3 className="sc-card-name">{r.subcategory || "—"}</h3>
                  <span className={`sc-badge ${r.status === "Active" ? "sc-badge-green" : "sc-badge-gray"}`}>
                    <span className="sc-badge-dot" />{r.status}
                  </span>
                </div>
                <div className="sc-card-parent">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                    <rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/>
                    <rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>
                  </svg>
                  {getMainName(r)}
                </div>
                <div className="sc-card-footer">
                  <button className="sc-icon-btn sc-icon-edit" onClick={() => openEdit(r)}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                      <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
                      <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
                    </svg>
                    Edit
                  </button>
                  <button className="sc-icon-btn sc-icon-delete" onClick={() => remove(r.id)}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                      <polyline points="3 6 5 6 21 6"/>
                      <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                      <path d="M10 11v6"/><path d="M14 11v6"/>
                      <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                    </svg>
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Modal */}
      {open && (
        <div className="sc-overlay" onMouseDown={closeModal}>
          <div className="sc-modal" onMouseDown={(e) => e.stopPropagation()}>
            <div className="sc-modal-head">
              <div className="sc-modal-head-left">
                <div className={`sc-modal-icon ${mode === "edit" ? "sc-modal-icon-edit" : ""}`}>
                  {mode === "edit" ? (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                      <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
                      <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
                    </svg>
                  ) : (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                      <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
                    </svg>
                  )}
                </div>
                <div>
                  <h3 className="sc-modal-title">{mode === "edit" ? "Edit Sub Category" : "Add Sub Category"}</h3>
                  <p className="sc-modal-sub">{mode === "edit" ? `Editing "${form.name}"` : "Create a new sub category"}</p>
                </div>
              </div>
              <button className="sc-close-btn" onClick={closeModal}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                  <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
            </div>
            <div className="sc-modal-body">
              {formErr && (
                <div className="sc-form-err">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" style={{flexShrink:0}}>
                    <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                  </svg>
                  {formErr}
                </div>
              )}
              <div className="sc-form-group">
                <label className="sc-label">Main Category</label>
                <select className="sc-input sc-select" value={form.category_id}
                  onChange={(e) => setForm((p) => ({ ...p, category_id: e.target.value }))}>
                  <option value="">Select main category…</option>
                  {mainCats.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
                </select>
              </div>
              <div className="sc-form-group">
                <label className="sc-label">Sub Category Name</label>
                <input className="sc-input" value={form.name}
                  onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))}
                  placeholder="e.g. Smartphones, T-Shirts…" autoFocus />
              </div>
              <div className="sc-form-group">
                <label className="sc-label">Status</label>
                <select className="sc-input sc-select" value={form.status}
                  onChange={(e) => setForm((p) => ({ ...p, status: e.target.value }))}>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </div>
              <div className="sc-modal-footer">
                <button className="sc-btn-cancel" onClick={closeModal}>Cancel</button>
                <button className={`sc-btn-save ${mode === "edit" ? "sc-btn-update" : ""}`}
                  onClick={mode === "edit" ? update : add} disabled={saving}>
                  {saving ? (
                    <><span className="sc-btn-spinner" />{mode === "edit" ? "Updating…" : "Saving…"}</>
                  ) : (
                    <>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                        <polyline points="20 6 9 17 4 12"/>
                      </svg>
                      {mode === "edit" ? "Update" : "Save"}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}